import axios from 'axios';

const publicApiClient = axios.create({
  baseURL: (window as any).ENV?.REACT_APP_API_URL || process.env.REACT_APP_API_URL,
  timeout: 30000,
});

export const publicApiService = {
  getTestResult: async (encryptedResultNo: string) => {
    const response = await publicApiClient.get(`/api/public/v1/health/test-results/${encryptedResultNo}`);
    return response.data;
  }
};